"use client";

import { useCallback, useMemo, useState } from "react";
import { useProductArContext } from "@/lib/providers/ProductArProvider";
import {
  isMobileDevice,
  isProductArEnabled,
  openProductAr,
  parseArLink,
} from "@/lib/utils/ar";

/**
 * Shared AR state for product page (native AR button + desktop prompt).
 * @param {object} product
 */
export function useProductAr(product) {
  const [showArPrompt, setShowArPrompt] = useState(false);
  const productAr = useProductArContext();
  const arEnabled = isProductArEnabled(product?.ar);
  const arLinks = useMemo(() => parseArLink(product?.ar_link), [product?.ar_link]);
  const hasArModel = arEnabled && !!arLinks.glb;

  const handleArClick = useCallback(async () => {
    if (!hasArModel) return;

    if (isMobileDevice()) {
      const activated = await productAr?.tryActivateAr?.();
      if (!activated) {
        openProductAr(arLinks);
      }
      return;
    }

    setShowArPrompt(true);
  }, [hasArModel, arLinks, productAr]);

  return {
    hasArModel,
    handleArClick,
    showArPrompt,
    setShowArPrompt,
  };
}
